import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
import { emailValidate } from "../../utils/validation";
import { useUser } from "../../hooks/useUser";

function ForgotPasswordSection() {
  const navigate = useNavigate();
  const { requestPasswordReset } = useUser();
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setEmailError("");
  }, [email]);

  const handleSignUp = () => {
    navigate(Paths.signup);
  };

  const handleReset = async () => {
    const invalidEmail = emailValidate(email);
    if (invalidEmail) {
      return setEmailError(invalidEmail);
    }
    await requestPasswordReset({ email, setLoading });
    navigate(`${Paths.recoverPassword}?email=${email}`);
  };

  return (
    <div className={ClassName.container}>
      <div className="bg-[#F8F8F8] rounded-2xl w-full max-w-[540px] py-6 px-3 lg:px-6 flex flex-col mx-2">
        <span className="text-3xl lg:text-4xl font-bold mb-4">
          Forgot password
        </span>
        <span className={ClassName.label}>Your email address</span>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={ClassName.input}
        />
        {emailError && <span className={ClassName.error}>{emailError}</span>}

        <button
          onClick={handleReset}
          className="h-12 w-full rounded-lg bg-primary text-white font-bold text-sm lg:text-base mt-4"
        >
          {loading ? "Please wait ..." : "Send reset link"}
        </button>
        <div className="w-full flex flex-col items-center">
          <span
            className={`${ClassName.label} cursor-pointer mt-0 text-[#B5B5B5]`}
          >
            Don't have an account?
            <span className="text-primary" onClick={handleSignUp}>
              {" "}
              Signup
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordSection;

const ClassName = {
  container: "w-full h-screen flex items-center justify-center",
  input:
    "border rounded-lg flex flex-1 px-4 py-3 bg-transparent border-[#DBDBDB]",
  error: "text-red-600 text-sm mt-2 mb-2",
  label: "text-[#818083] text-sm lg:text-base font-bold mb-1 mt-4",
};
